var _rect, _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationReceived(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Grupo_930",
    "data-name": "Grupo 930",
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_616",
    "data-name": "Ret\\xE2ngulo 616",
    width: 80,
    height: 80,
    rx: 40,
    fill: "#8acb23"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_66",
    "data-name": "Elipse 66",
    cx: 10,
    cy: 10,
    r: 10,
    transform: "translate(60)",
    fill: "#f48811"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_39021",
    "data-name": "Caminho 39021",
    d: "M58.637,46.3l-31.612,8.47a1.818,1.818,0,0,1-1.845-2.95c.017,0,3.584-4.537.634-15.548a12.736,12.736,0,0,1,24.6-6.593c2.951,11.012,8.3,13.136,8.363,13.157a1.848,1.848,0,0,1,1.194,1.788A1.817,1.817,0,0,1,58.637,46.3ZM29.842,50.251l24.1-6.456c-2.277-2.176-5.149-6.15-7.031-13.175a9.091,9.091,0,0,0-17.562,4.706C31.226,42.351,30.744,47.224,29.842,50.251Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_39022",
    "data-name": "Caminho 39022",
    d: "M45.166,59.321a5.421,5.421,0,0,1-5.25-1.4,1.821,1.821,0,0,1,2.563-2.588,1.74,1.74,0,0,0,.8.463,1.831,1.831,0,0,0,2.237-1.277,1.821,1.821,0,0,1,3.514.96A5.443,5.443,0,0,1,45.166,59.321Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationReceived);
export default __webpack_public_path__ + "static/media/notificationReceived.740f208f0eca9b8722c1a1c65eaa7cae.svg";
export { ForwardRef as ReactComponent };